import * as React from 'react';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';

export interface PopupDialogProps{
	isOpen: boolean,
	title: string,
	text: string,
	onClose?: () => void
}

export interface PopupDialogState{
	isOpen: boolean
}

export class PopupDialog extends React.Component<PopupDialogProps, PopupDialogState> {

	constructor(props: PopupDialogProps){
		super(props);

		this.state = {
			isOpen: props.isOpen
		}
	}

	componentWillReceiveProps(nextProps: PopupDialogProps) {
		this.setState({ isOpen: nextProps.isOpen })
	}

	handleOk() {
		this.setState({ isOpen: !this.state.isOpen })
		if (this.props.onClose) this.props.onClose()
	}

	render(): React.ReactNode {

		let open = this.state.isOpen

		return(<Dialog
			disableBackdropClick
			disableEscapeKeyDown
			maxWidth="xs"
			open={open} >
			<DialogTitle id="popup-dialog-title">{this.props.title}</DialogTitle>
			<DialogContent dividers>
				<p>{this.props.text}</p>
			</DialogContent>
			<DialogActions><Button onClick={() => this.handleOk()} color="primary">Ok</Button>
			</DialogActions>
		</Dialog>)
	}
}
